var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioAboutme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428.15 458.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-5 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-4, .cls-7 {\n        stroke: #fff;\n      }\n\n      .cls-2, .cls-9, .cls-10, .cls-11, .cls-12, .cls-3, .cls-13, .cls-14, .cls-15, .cls-5, .cls-6, .cls-8 {\n        stroke: #2d473d;\n      }\n\n      .cls-9, .cls-10, .cls-11, .cls-12, .cls-3, .cls-4, .cls-13, .cls-14, .cls-15, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-9, .cls-10, .cls-11, .cls-12, .cls-5, .cls-6 {\n        stroke-width: 2px;\n      }\n\n      .cls-9, .cls-13 {\n        fill: #b7ce8c;\n      }\n\n      .cls-10, .cls-14 {\n        fill: #f5f1e9;\n      }\n\n      .cls-11, .cls-16 {\n        fill: #2d473d;\n      }\n\n      .cls-12, .cls-15 {\n        fill: #d3c7af;\n      }\n\n      .cls-16, .cls-17 {\n        stroke-width: 0px;\n      }\n\n      .cls-17 {\n        fill: #718e56;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m143.39,225.93l24.78,203.71c-31.58,18.58-57.59-2.32-57.59-2.32l-14.86-150-26.41,152.24c-30.07,19.61-58.39-3.92-58.39-3.92l40.17-202.7,92.3,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m135.53,68.18c.34,3.78.47,7.62.26,11.41-.12,2.01-.09,4.9-1.21,6.63-2.08,3.19-6.07,3.24-6.07,3.24,0,0-15.61,2.78-20.12-.76-1.89-1.49-5.82-1.31-10.24-.44-.71-3.69-.48-7.18-.39-8.22-2.34,1.45-4.98,2.34-7.93,2.58-3.19.26-6.2-.3-8.95-1.5.12.46,1.89,6.54.57,12-.22.07-.41.13-.61.2-6.83,2.23-10.38.84-10.38.84,0,0-7.3,1.04-12.98-3.13-3.71-2.73-7.32-2.47-11.4-1.34-2.57-6.34-3.92-13.23-3.97-20.11-.03-3.43.31-7,1.94-9.94,1.16-2.11,2.97-3.81,5.08-4.78,1.85-.86,3.95-1.17,5.68-2.3,2.76-1.83,4.02-5.44,4.45-8.89.19-1.51.27-3.03.3-4.58.11-4.45-.05-8.96,1.63-12.98,1.33-3.21,3.75-5.78,6.47-7.76,5.87-4.26,12.71-5.2,19.28-3.16-1.04-2.38-1.23-5.09-.37-7.63,1.87-5.39,7.87-7.97,13.44-5.77,5.54,2.22,8.54,8.37,6.68,13.76-.23.7-.55,1.35-.92,1.95,3.13.68,5.62,2.5,7.87,4.77,2.51,2.51,4.71,5.59,7.21,8.35,3.32,3.68,5.51,7.75,7.23,12.47,3.13,8.49,6.6,15.87,7.45,25.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m64.27,54.42c-4.37-2.23-5.33,3.66-4.26,6.74s4.02,4.85,6.6,3.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m110.25,50.71c3.96-2.9,5.85,2.75,5.29,5.96s-3.19,5.44-5.88,4.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m76.27,46.93l28.82-4.23h.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m108.76,42.95s.02.07.03.11c.81,2.26,1.28,4.65,1.39,7.13v.09c.04.72.04,1.44,0,2.16-.06,1-.14,2-.26,2.97v.03c-1.13,10.76-5.27,20.1-12.16,24.5-1.09.71-2.25,1.29-3.48,1.73-.41.15-.82.27-1.25.39-.29.07-.57.15-.87.21-.16.04-.31.06-.47.09-.25.05-.5.09-.76.13-.36.05-.73.1-1.1.13-.79.06-1.59.08-2.36.04-.29-.01-.58-.04-.86-.07-1.99-.19-3.92-.75-5.73-1.58h0c-8.03-3.74-13.93-13.36-15.97-24.9-.41-2.28-.5-4.54-.32-6.73,0-.06,0-.13,0-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m80.87,81.09h.01s0,.02,0,.02c.13.46,1.88,6.55.57,12-.86,3.6-3.07,6.94-7.96,8.18-.07.02-.14.03-.21.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m63.35,50.1s6.54.57,11.85-2.52,6.45-8.43,10.72-10.43,8.74-3.28,8.74-3.28c0,0,2.88,7.4,15.01,9.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m97.8,79.72s-.01.11-.03.3c-.09,1.05-.32,4.53.39,8.22.9,4.77,3.37,9.86,9.73,10.32.08,0,.15.01.22.02.3.03.62.05.91.08.06,0,.1.01.16.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m84.96,71.14s.89,1.18,3.47,1.18,4-1.79,4-1.79"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 97.05,
    cy: 53.22,
    rx: 1.88,
    ry: 3.25,
    transform: "translate(-3.97 7.99) rotate(-4.62)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 77.51,
    cy: 54.12,
    rx: 1.88,
    ry: 3.25,
    transform: "translate(-4.11 6.42) rotate(-4.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m87.48,55.87s.22,5.08-1.77,5.92,1.41,3.47,1.41,3.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m182.91,95.04c-4.43,5.9-9.09,11.41-13.92,15.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m183.53,55.4c-5.18,5.17-11.49,11.08-18.56,16.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m43.1,187.97c-.99,4.88-1.47,10.11-.97,15.36,2,21,19.32,28.18,19.32,28.18l-9.45,15.17s18.68,9.35-6.53-3.25S7.67,220.13,1.56,197.22c-1.7-6.39.6-15.26,5.03-24.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m117.1,431.34l2.69,21.4s33.76,10.23,52.24-2.98-31.41-24.47-31.41-24.47l-23.52,6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m62.97,431.34l-2.69,21.4s-33.76,10.23-52.24-2.98c-18.49-13.21,31.41-24.47,31.41-24.47l23.52,6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m168.99,110.82c-18.16,18.85-37.3,26.65-37.3,26.65l11.7,88.46s-27.69,7.54-49.31,8.6-42.98-11.6-42.98-11.6l2.64-61.18s-7.65,11.58-10.63,26.23l-36.5-15.67c11.46-24.96,37.14-55.14,44.5-61.06,10.2-8.21,22.39-9.95,22.39-9.95,0,0,18.71,13.51,34.61-2.71,0,0,28.21-4.74,47.4-18.86,3.28-2.41,6.44-4.9,9.47-7.4l4.02,38.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m204.93,28.86c-.1.04-.21.07-.31.12-12.62,4.58-21.71,17.6-21.71,32.92v360.9c0,19.17,14.21,34.7,31.75,34.7h180.74c17.53,0,31.75-15.53,31.75-34.7V61.9c0-19.16-14.22-34.7-31.75-34.7h-167.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 182.9,
    y1: 69.36,
    x2: 427.15,
    y2: 69.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 213.25,
    cy: 48,
    rx: 6.83,
    ry: 6.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 233.79,
    cy: 48.22,
    rx: 6.83,
    ry: 6.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 254.33,
    cy: 48.22,
    rx: 6.83,
    ry: 6.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m212.99,37.15c1.53,1.03,3.36,1.62,5.35,1.97.21.04.42.07.64.11,1.31.21,2.66.34,3.95.03,4.33-1.05,6.03-5.29,5.98-9.35-.03-2.18-.7-4.33-2.15-5.99-2.49-2.85-6.52-3.75-10.14-3.97-13.49-.81-12.3,9.14-12.3,9.14,0,0,3.3-.86,3.3-.86.61,2.01,1.44,4.01,2.5,5.83.77,1.32,1.74,2.32,2.87,3.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 182.9,
    y: 69.36,
    width: 244.25,
    height: 75.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m351.36,144.93c0,12.05-5.2,22.96-13.61,30.86-8.38,7.86-19.94,12.72-32.72,12.72s-24.46-4.91-32.85-12.85c-8.33-7.88-13.48-18.73-13.48-30.73,0-24.06,20.74-43.57,46.33-43.57s46.33,19.51,46.33,43.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 244.9,
    cy: 262.39,
    r: 39.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 356.09,
    cy: 262.39,
    r: 39.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 244.9,
    cy: 360.66,
    r: 39.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 356.09,
    cy: 360.66,
    r: 39.47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 243.49,
    y: 245.85,
    width: 28.29,
    height: 8.81,
    transform: "translate(252.42 -108.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "248.52 247.38 235.41 252.3 224.61 283.59 255.29 271.16 260.71 259.57"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 244.93,
    cy: 262.97,
    r: 3.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 224.61,
    y1: 283.59,
    x2: 242.28,
    y2: 265.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 220.5,
    y: 342.89,
    width: 49.41,
    height: 29.28,
    rx: 6.07,
    ry: 6.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "251.26 372.18 254.08 382.11 234.94 382.11 237.76 372.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 230.73,
    y1: 357.13,
    x2: 238.37,
    y2: 352.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 238.37,
    y1: 362.15,
    x2: 230.73,
    y2: 357.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.69,
    y1: 357.13,
    x2: 252.06,
    y2: 352.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 252.06,
    y1: 362.15,
    x2: 259.69,
    y2: 357.13
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 247.29,
    y1: 349.87,
    x2: 242.35,
    y2: 364.39
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 331.39,
    y: 244.28,
    width: 49.41,
    height: 36.21,
    rx: 6.07,
    ry: 6.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "354.83 273.41 364.01 273.41 373.2 273.41 364.01 257.55 358.34 267.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "353.01 261.68 342.01 273.41 364.01 273.41 353.01 261.68"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 342.01,
    cy: 253.52,
    r: 4.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 338.66,
    y: 336.46,
    width: 15.71,
    height: 15.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 338.66,
    y1: 340.97,
    x2: 354.37,
    y2: 340.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 338.66,
    y: 363.58,
    width: 15.71,
    height: 15.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 338.66,
    y1: 368.09,
    x2: 354.37,
    y2: 368.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.91,
    y: 363.58,
    width: 15.71,
    height: 15.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 359.91,
    y1: 368.09,
    x2: 375.62,
    y2: 368.09
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 346.51,
    y1: 355.76,
    x2: 346.51,
    y2: 359.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 346.51,
    y1: 360.03,
    x2: 348.62,
    y2: 358.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 346.46,
    y1: 360.03,
    x2: 344.36,
    y2: 358.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 367.79,
    y1: 360.01,
    x2: 369.89,
    y2: 358.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 367.74,
    y1: 360.01,
    x2: 365.64,
    y2: 358.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "358.46 344.32 367.79 344.32 367.79 355.74 367.79 359.98"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m333.74,149.86c.21,2.35.29,4.73.16,7.08-.08,1.25-.06,3.04-.75,4.11-1.29,1.98-3.77,2.01-3.77,2.01,0,0-9.68,1.72-12.48-.47-1.17-.92-3.61-.81-6.35-.27-.44-2.29-.3-4.46-.24-5.1-1.45.9-3.09,1.45-4.92,1.6-1.98.16-3.85-.18-5.55-.93.08.29,1.17,4.06.35,7.45-.14.04-.26.08-.38.12-4.24,1.38-6.44.52-6.44.52,0,0-4.53.64-8.05-1.94-2.3-1.69-4.54-1.53-7.07-.83-1.59-3.93-2.43-8.21-2.46-12.47-.02-2.13.19-4.34,1.2-6.17.72-1.31,1.84-2.37,3.15-2.97,1.15-.53,2.45-.72,3.52-1.43,1.72-1.13,2.49-3.38,2.76-5.51.12-.94.16-1.88.19-2.84.07-2.76-.03-5.56,1.01-8.05.83-1.99,2.33-3.59,4.01-4.81,3.64-2.64,7.89-3.22,11.96-1.96-.64-1.48-.77-3.16-.23-4.73,1.16-3.34,4.88-4.94,8.34-3.58,3.44,1.37,5.3,5.19,4.14,8.54-.14.44-.34.84-.57,1.21,1.94.42,3.48,1.55,4.88,2.96,1.55,1.56,2.92,3.47,4.47,5.18,2.06,2.28,3.42,4.81,4.49,7.74,1.94,5.26,4.09,9.85,4.62,15.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m289.53,141.32c-2.71-1.38-3.31,2.27-2.64,4.18s2.49,3.01,4.1,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m318.06,139.02c2.45-1.8,3.63,1.71,3.28,3.7s-1.98,3.37-3.65,3.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m296.98,136.67l17.88-2.63h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m317.13,134.2s.01.05.02.07c.5,1.4.8,2.89.86,4.42v.05c.03.45.02.89,0,1.34-.03.62-.09,1.24-.16,1.84v.02c-.7,6.68-3.27,12.47-7.54,15.2-.67.44-1.39.8-2.16,1.07-.26.09-.51.17-.78.24-.18.05-.36.09-.54.13-.1.02-.19.04-.29.05-.15.03-.31.06-.47.08-.22.03-.45.06-.68.08-.49.04-.98.05-1.47.02-.18,0-.36-.03-.54-.04-1.24-.12-2.43-.47-3.55-.98h0c-4.98-2.32-8.64-8.29-9.91-15.45-.25-1.42-.31-2.82-.2-4.17,0-.04,0-.08,0-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m299.83,157.87h0s0,.01,0,.01c.08.29,1.17,4.06.35,7.44-.53,2.24-1.91,4.3-4.94,5.08-.04.01-.09.02-.13.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m288.96,138.64s4.06.36,7.35-1.56c3.3-1.92,4-5.23,6.65-6.47s5.42-2.03,5.42-2.03c0,0,1.79,4.59,9.31,6.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m310.33,157.02s0,.07-.02.19c-.06.65-.2,2.81.24,5.1.56,2.96,2.09,6.12,6.03,6.4.05,0,.09,0,.14,0,.19.02.38.03.57.05.04,0,.06,0,.1.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m307.41,151.59s-1.28.84-2.88.84-2.72-.84-2.72-.84c0,0,.86,1.76,2.06,2.65s3.55-2.65,3.55-2.65Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 309.87,
    cy: 140.58,
    rx: 1.17,
    ry: 2.01,
    transform: "translate(-10.32 25.42) rotate(-4.62)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 297.75,
    cy: 141.14,
    rx: 1.17,
    ry: 2.01,
    transform: "translate(-10.4 24.45) rotate(-4.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m303.93,142.22s.14,3.15-1.1,3.68.87,2.15.87,2.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m337.75,175.79c-8.38,7.86-19.94,12.72-32.72,12.72s-24.46-4.91-32.85-12.85c3.87-2.38,11.19-5.42,23.08-5.26,0,0,10.23,10.71,21.33-1.69,0,0,15.65.14,21.16,7.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioAboutme);
export default __webpack_public_path__ + "static/media/portfolio-aboutme.a215bdec7e710128298664014b519378.svg";
export { ForwardRef as ReactComponent };